import { Component } from '@angular/core';

@Component({
  selector: 'app-foundation',
  templateUrl: './foundation.component.html',
  styleUrl: './foundation.component.scss'
})
export class FoundationComponent {

}
